import { createAsyncThunk } from '@reduxjs/toolkit';

import { IAuthFailure, IUserInfo } from './types';

import { classifySessionError, getAuthenticatedSession } from 'core/services/Auth';

const loadUserInfo = async (): Promise<IUserInfo> => {
  const { attributes, permissions, username } = await getAuthenticatedSession();

  return {
    ...attributes,
    permissions,
    username,
  } as IUserInfo;
};

export const getUserInfo = createAsyncThunk<
  // Return type of the payload creator
  IUserInfo,
  // First argument to the payload creator
  void,
  // Types for ThunkAPI
  {
    rejectValue: IAuthFailure;
  }
>('user/get', async (_, thunkApi) => {
  try {
    return await loadUserInfo();
  } catch (error) {
    const sessionError = classifySessionError(error);

    return thunkApi.rejectWithValue({
      kind: sessionError.kind,
      message: sessionError.message,
    });
  }
});

export const getUserInfoShadow = createAsyncThunk<
  // Return type of the payload creator
  IUserInfo,
  // First argument to the payload creator
  void,
  // Types for ThunkAPI
  {
    rejectValue: IAuthFailure;
  }
>('user/get/shadow', async (_, thunkApi) => {
  try {
    return await loadUserInfo();
  } catch (error) {
    const sessionError = classifySessionError(error);

    return thunkApi.rejectWithValue({
      kind: sessionError.kind,
      message: sessionError.message,
    });
  }
});
